/*
  This is a template for creating a Component class.

  Instructions: copy and paste this file into your newly created react component index.js. Then
  change the appropriate names and add your html render
    The base class for all components should be BaseClass (as indicated in this file)
    The base class insures that all call back handlers with "handle" in the name are bound
    to "this". This insures that "this" is defined as "this" for the containing class
*/

import React from 'react';

import BaseComponent from '../../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure
import './DialogButton.scss';

// Change DialogButton to the appropriate name
class DialogButton extends BaseComponent {

  constructor(props) {
    super(props);

    // Initialize all expected state variable here
    this.state={ initializeMe: null };
  }

  componentDidMount() {
  }

  // All event handlers or callback functions that need to have "this" available
  // Need to have "handle" (case in-sensitive) in the name. Matching names would be:
  //    handleResponse
  //    dateTimeHandler
  //    HandlesMessiah (not Handels however)
  handleMyClick(e){
    e.stopPropagation();
    const{ handleClick } = this.props;
    if (handleClick){
      handleClick(e);
    }
  }

  changeBackground(e, text, hover=false) {
    if(text && text.toLowerCase() === 'clear') {
      if(hover){
        e.target.style.border = 'solid 1px #5db348';
        e.target.style.color = '#5db348';
        e.target.style.borderRadius = '4px';
      } else {
        e.target.style.removeProperty('border');
        e.target.style.removeProperty('color');
        e.target.style.removeProperty('borderRadius');
      }
    }
  }

  render() {
    let { 
      width, 
      height, 
      left, 
      top, 
      right, 
      bottom, 
      position, 
      text, 
      fontStyle, 
      fill, 
      disabled, 
      border,
    } = this.props;

    let style = {};
    if (width){
      style.width = width;
    }
    if (height){
      style.height = height;
    }
    if (left){
      style.left = left;
    }
    if (top){
      style.top = top;
    }
    if (right){
      style.right = right;
    }
    if (bottom){
      style.bottom = bottom;
    }
    if (position){
      style.position = position;
    }
    if (fill) {
      style.backgroundColor = fill;
    }
    if(disabled){
      style.cursor = 'auto';
    }
    if(border){
      style.border = border;
    }
    return (
      // Replace with the appropriate HTML
      <div className="dialog-button" onClick={this.handleMyClick} style={style} onMouseOver={event => this.changeBackground(event, text, true)} onMouseOut={event => this.changeBackground(event, text, false)}>
        <div className="dialog-button-text" style={fontStyle}>{text}</div>
      </div>
    );
  }
}

export default (DialogButton);



// WEBPACK FOOTER //
// ./src/components/Buttons/DialogButton/index.js